import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-component',
  templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent implements OnInit {

  private sub: any;
  public permissoes: any[] = [];
  errorCode: string;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.errorCode = params['type'];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/unauthorized/component/unauthorized.component.ts